export const normalizeProfileResponse = payload => {
	if (!payload) {
		return {
			email: '',
			first_name: '',
			last_name: '',
			birthday: '',
		};
	}

	const user = payload.user ?? {};

	return {
		email: payload.email ?? user.email ?? '',
		first_name: payload.first_name ?? user.first_name ?? '',
		last_name: payload.last_name ?? user.last_name ?? '',
		birthday: payload.birth_date ?? payload.birthday ?? '',
	};
};
